// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__18iQr","navLink":"styles_navLink__39_ND"};